module.exports = __webpack_public_path__ + "static/media/TriumphSixPackrallyposter2011cutpaperoriginal4colorscreenprint.6ac89027.webp";